var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 27.242,
    width: 54,
    height: 26.742,
    rx: 13.371,
    transform: "rotate(-180 55 27.242)",
    stroke: "#456D45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.603 10.899c-.508 1.084-.983 1.897-1.425 2.439H37.5v1.067H23.178c.442.542.917 1.354 1.425 2.438h-.86c-1.032-1.236-2.113-2.15-3.243-2.743v-.458c1.13-.575 2.211-1.49 3.243-2.743h.86z",
    fill: "#456D45"
  })));
}
export default SvgBack;